import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import styles from "./NewRolePage.module.scss";
import { AxiosResponse, AxiosErrorType } from "../../../src/types";

interface FormValues {
  name: string;
  permissions: Record<string, boolean>;
  issuperadmin: boolean;
}

const NewUserTypePage: React.FC = () => {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState<FormValues>({
    name: "",
    permissions: {},
    issuperadmin: false,
  });
  const [error, setError] = useState<string>("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePermissionsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      setFormValues((prev) => ({
        ...prev,
        permissions: JSON.parse(e.target.value || "{}"),
      }));
    } catch (err) {
      setError("Invalid JSON format for permissions");
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const response = await api.post("/core/role/usertype/create", {
        name: formValues.name,
        permissions: formValues.permissions,
        issuperadmin: formValues.issuperadmin,
      });
      console.log("User type created:", response.data);
      navigate("/roles");
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Failed to create user type";
      setError(errorMessage);
    }
  };

  return (
    <div className={styles.container}>
      <h2>Add New User Type</h2>
      {error && <div className={styles.error}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label htmlFor="name">User Type Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formValues.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="issuperadmin">
            <input
              type="checkbox"
              id="issuperadmin"
              name="issuperadmin"
              checked={formValues.issuperadmin}
              onChange={handleInputChange}
            />
            Superadmin
          </label>
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="permissions">Permissions (JSON)</label>
          <input
            type="text"
            id="permissions"
            name="permissions"
            value={JSON.stringify(formValues.permissions)}
            onChange={handlePermissionsChange}
            placeholder='{"view": true, "edit": false}'
          />
        </div>
        <button type="submit">Create User Type</button>
      </form>
    </div>
  );
};

export default NewUserTypePage;
